import { RootState } from 'modules'
import { INewsItemProps } from 'pages/App/components/Sidebar/SidebarInfo/News/NewsItem'

export const selectThiefList = (
  state: RootState
): Array<INewsItemProps> | null => state.thieves.list

export const selectThiefFetchedStatus = (state: RootState): boolean =>
  state.thieves.fetched
